module.exports = __webpack_public_path__ + "media/images/icon__twitter@3x-49d98015a3d09b7ef5b24189abb9c315.png";